import { Vector2 } from "three";
import { OnAnimationFrame } from "../../../library-js/animation/OnAnimationFrame";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { contextmenu, OnClick, OnMouseEnter, OnMouseLeave } from "../../../library-js/dom-tools/EventListeners";
import { InputManager } from "../../../library-js/dom-tools/InputManager";
import { DOMOrientation } from "../../../library-js/dom/DOMOrientation";
import { ContextMenu } from "../../../library-templates/context--menu/ContextMenu";
import { ContextMenuCreator } from "../../../library-templates/context--menu/ContextMenuCreator";
import { RJContextMenus } from "./RokojoriContextMenuLibrary";

export class RokojoriContextMenu
{  
  static readonly library = new RJContextMenus();
  protected static _openContextMenus = new Map<string,ContextMenu>(); 
  protected static _contextMenuLayerType = new ElementType( "context-menu-layer" );
  protected static _contextMenuLayer:Element;
  protected static _initialized = false;
  protected static _inputManager:InputManager

  static applyOnDocument( onAnimationFrame:OnAnimationFrame, inputManager:InputManager )
  {
    if ( ! RokojoriContextMenu._initialized )
    {       
      RokojoriContextMenu._inputManager = inputManager;

      onAnimationFrame.addListener( e => RokojoriContextMenu._update() );

      RokojoriContextMenu._initialized = true;
    }

    RokojoriContextMenu.closeAllOpenMenusExcept( null );

    // console.log( "Checking context menus" );
    ContextMenuCreator.attribute.forEachInDoc( e => RokojoriContextMenu.applyOnElement( e ) );

  }

  static _update()
  {
    let removals:string[] = [];

    this._openContextMenus.forEach(
      ( v, k )=>
      {
        v.update( RokojoriContextMenu._inputManager );

        if ( ! v.active )
        {
          removals.push( k );
        }
      }
    );

    removals.forEach( k => RokojoriContextMenu._openContextMenus.delete( k ) );
  }

  static ensureContextMenuLayer()
  {
    if ( RokojoriContextMenu._contextMenuLayer )
    {
      return;
    }

    RokojoriContextMenu._contextMenuLayer = RokojoriContextMenu._contextMenuLayerType.create();

    document.body.appendChild( RokojoriContextMenu._contextMenuLayer );
  }

  static closeAllOpenMenusExcept( cm:ContextMenu )
  {
    this._openContextMenus.forEach(
      ( otherCM )=>
      { 
        if ( otherCM === cm )
        {
          return;
        }

        otherCM.close();
        
      }
    )
  }

  static openMenu( attachElement:Element, type:string, contextMenuCreator:()=>ContextMenu, anchorsUV?:Vector2, boundsUV?:Vector2, offsetPixels?:Vector2 )
  {    
    if ( RokojoriContextMenu._openContextMenus.has( type ) )
    {
      let cm = RokojoriContextMenu._openContextMenus.get( type );
      cm.dontHide();
      cm.attachTo( attachElement, anchorsUV, boundsUV, offsetPixels );
      cm.triggerVisible();

      this.closeAllOpenMenusExcept( cm );
      return;
    }

    let contextMenu = contextMenuCreator();

    if ( ! contextMenu )
    {
      return;
    }

    RokojoriContextMenu._openContextMenus.set( type, contextMenu );

    RokojoriContextMenu.ensureContextMenuLayer();
    this.closeAllOpenMenusExcept( contextMenu );

    contextMenu.show( RokojoriContextMenu._contextMenuLayer, attachElement );
  }

  static addContextMenuElement( element:Element, type:string, creator:()=>ContextMenu, anchorsUV?:Vector2, boundsUV?:Vector2, offsetPixels?:Vector2 )
  {
    OnMouseLeave.add( element as HTMLElement, 
      ( e )=>
      {       
        if ( RokojoriContextMenu._openContextMenus.has( type ) )
        {
          let cm = RokojoriContextMenu._openContextMenus.get( type );
          cm.canHide();
          return;
        }
      }
    );

    OnMouseEnter.add( element as HTMLElement, 
      ( e )=>
      {
        if ( DOMOrientation.isPortrait )
        {
          return;
        }        
        
        RokojoriContextMenu.openMenu( element, type, creator, anchorsUV, boundsUV, offsetPixels );

      }
    );
  }

  static applyOnElement( element:Element )
  {

    OnMouseLeave.add( element as HTMLElement, 
      ( e )=>
      {
        

        let type = ContextMenuCreator.attribute.from( element );

        if ( RokojoriContextMenu._openContextMenus.has( type ) )
        {
          let cm = RokojoriContextMenu._openContextMenus.get( type );
          cm.canHide();
          return;
        }
      }
    );

    OnMouseEnter.add( element as HTMLElement, 
      ( e )=>
      {
        if ( DOMOrientation.isPortrait )
        {
          return;
        }
        
        let type = ContextMenuCreator.attribute.from( element );
        
        RokojoriContextMenu.openMenu( element, type, () => RokojoriContextMenu.library.create( element ) );

      }
    );
  }
}